const market = [{
  desc: '添加营销方案',
  options: {
    url: '/market/addMarketing',
    method: 'post'
  }
}, {
  desc: '删除营销方案',
  options: {
    url: '/market/deleteMarketing',
    method: 'post'
  }
}, {
  desc: '查询营销方案详情',
  options: {
    url: '/market/queryMarketing',
    method: 'post'
  }
}, {
  desc: '营销方案列表查询',
  options: {
    url: '/market/queryMarketings',
    method: 'post'
  }
}, {
  desc: '编辑营销方案',
  options: {
    url: '/market/updateMarketing',
    method: 'post'
  }
}, {
  desc: '获取营销策略配置条件字段接口(不分页)',
  options: {
    url: '/market/busiFieldsPage',
    method: 'post'
  }
}, {
  desc: '查询非车产品方案',
  options: {
    url: '/market/queryProductPlans',
    method: 'post'
  }
}, {
  desc: '获取非车险种',
  options: {
    url: '/market/queryFCInsTypes',
    method: 'post'
  }
}, {
  desc: '服务项目列表查询',
  options: {
    url: '/market/queryMarketingProductProject',
    method: 'post'
  }
}, {
  desc: '服务项目添加',
  options: {
    url: '/market/addMarketingProductProject',
    method: 'post'
  }
}, {
  desc: '服务项目编辑',
  options: {
    url: '/market/updateMarketingProductProject',
    method: 'post'
  }
}]
export default market



// WEBPACK FOOTER //
// ./src/api/market.js